import React, { useEffect } from "react";
import { CustomerData } from "../models/customer";

export const useCustomerData = () => {
    const [customer, setCustomer] = React.useState<CustomerData>();
    const [ loading, setLoading ] = React.useState<boolean>(false);

    useEffect(() => {
        setupCustomerdataConfig();
    },[]);

    async function setupCustomerdataConfig(): Promise<void> {
        setLoading(true);
        const customerInfo = window.sessionStorage.getItem('Customerdata');
        try {
            if (!customerInfo) return;
            const customerData = JSON.parse(customerInfo);
            setCustomer(customerData);
        } catch (error: any) {
            console.error(error);
            return;
        }
        setLoading(false);   
    }

    return { customer, loading };
}